import React, { useState, useEffect, useMemo } from "react";
import "./subject.css";
import { subjectsData } from "../../data/lessonlist.js";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Tabs,
  Tab,
  Button,
} from "@mui/material";

const SubjectsLibrary = ({ onSelect, open, onClose, selectedSubjects, region }) => {

  const regionSubjects = useMemo(() => subjectsData[region] || {}, [region]);

  const [selectedCategory, setSelectedCategory] = useState(
    "custom-lessons"
  );
  const [customLesson, setCustomLesson] = useState("");
  const [customLessons, setCustomLessons] = useState([]);

  const handleAddCustomLesson = () => {
    if (customLesson.trim()) {
      const updatedLessons = [...selectedSubjects, customLesson.trim()];
      setCustomLessons([...customLessons, customLesson.trim()]);
      onSelect(updatedLessons);
      setCustomLesson("");
    }
  };

  const handleRemoveLesson = (lessonToRemove) => {
    const updatedLessons = selectedSubjects.filter((s) => s !== lessonToRemove);
    setCustomLessons(customLessons.filter((l) => l !== lessonToRemove));
    onSelect(updatedLessons);
  };

  const handleToggle = (subject) => () => {
    const currentIndex = selectedSubjects.indexOf(subject);
    const newSelected = [...selectedSubjects];
  
    if (currentIndex === -1) {
      newSelected.push(subject);
    } else {
      newSelected.splice(currentIndex, 1);
    }
  
    onSelect(newSelected); // update parent
  };

  const handleDone = () => {
    onSelect(selectedSubjects);
    onClose();
  };

  const handleTabChange = (event, newValue) => {
    setSelectedCategory(newValue);
  };


  useEffect(() => {
    const customOnly = selectedSubjects.filter(
      (s) => !Object.values(regionSubjects).flat().includes(s)
    );
    setCustomLessons(customOnly);
  }, [selectedSubjects, region, regionSubjects]);
  

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle> LESSON LIBRARY 📚</DialogTitle>
      <DialogContent>
        <Tabs
          value={selectedCategory}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{ style: { backgroundColor: '#70d694' } }}
        >
          <Tab key="custom-lessons" label="Custom Lessons ✨" value="custom-lessons" />
          {Object.keys(regionSubjects).map((category) => (
            <Tab key={category} label={category} value={category} />
          ))}
        </Tabs>

        {selectedCategory === "custom-lessons" ? (
          <>
            <div
              className="custom-lesson-div"
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <input
                className="custom-lesson-input"
                type="text"
                value={customLesson}
                onChange={(e) => setCustomLesson(e.target.value)}
                placeholder="Type your lesson here"
                style={{ flexGrow: 1, padding: "12px", margin: "8px 0" }} // input grows to fill available space
              />
              <Button
                className="add-custom-lesson-btn"
                onClick={handleAddCustomLesson}
                variant="contained"
                sx={{
                  backgroundColor: "#3f4041",
                  "&:hover": { backgroundColor: "#6b6c6d" },
                }}
              >
                Add Lesson
              </Button>
            </div>
            <List>
              {customLessons.map((lesson) => (
                <ListItem key={lesson} button onClick={handleToggle(lesson)}>
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={selectedSubjects.indexOf(lesson) !== -1}
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText primary={lesson} />
                  <Button
                    onClick={() => handleRemoveLesson(lesson)}
                    style={{ marginLeft: "auto", color: "red" }} // Adjust color and margin as needed
                  >
                    X
                  </Button>
                </ListItem>
              ))}
            </List>
          </>
        ) : (
          <List>
            {regionSubjects[selectedCategory]?.map((subject) => (
              <ListItem key={subject} button onClick={handleToggle(subject)}>
                <ListItemIcon>
                  <Checkbox checked={selectedSubjects.includes(subject)} />
                </ListItemIcon>
                <ListItemText primary={subject} />
              </ListItem>
            ))}
          </List>
        )}
{selectedSubjects.length > 0 && (
<Button
    onClick={handleDone}
    variant="contained"
    sx={{
      backgroundColor: "#22c55e",
      "&:hover": { backgroundColor: "#16a34a" },
      position: 'sticky',
      bottom: 0,
      width: '100%',
      marginTop: '16px'
    }}
  >
    Done
  </Button>
  )}
      </DialogContent>
    </Dialog>
  );
};

export default SubjectsLibrary;
